<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="errorMessage")
  DashboardConfiguration(
    :dashboards="dashboards"
    :isFetching="isFetching"
    :isSaving="isSaving"
    @save="save"
    )
</template>

<script>
import DashboardConfiguration from './DashboardConfiguration.vue'

export default {
  name: 'DashboardConfigurationWrapper',
  components: { DashboardConfiguration },
  data() {
    return {
      dashboards: [],
      isFetching: true,
      isSaving: false,
      response: null,
      fetchError: null,
    }
  },
  computed: {
    errorMessage() {
      return this.fetchError
        ? 'An error occured while trying to retrieve dashboard configuration'
        : null
    },
  },
  methods: {
    async save(dashboards) {
      this.isSaving = true
      try {
        const response = await this.$apiClient.post('settings/dashboard-configuration', dashboards)
        this.dashboards = response.data
      } catch (e) {
        this.$logError('error:', e)
        this.$notifyError('Something went wrong')
      }
      this.isSaving = false
    },
  },
  async mounted() {
    this.isFetching = true
    try {
      const response = await this.$apiClient.get('settings/dashboard-configuration')
      this.response = response
      this.dashboards = response.data || []
    } catch (e) {
      this.fetchError = e
      this.$logError('error:', e)
      this.$notifyError('Could not retrieve dashboard configuration')
    }
    this.isFetching = false
  },
}
</script>
